import ReactPaginate from "react-paginate";
import Table from "../../../components/Table/Table";
import AlertDialog from "../../../components/ui/AlertDialog/AlertDialog";
import CommonCard from "../../../components/ui/CommonCard/CommonCard";
import classes from "./PastRequests.module.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { IoIosArrowRoundBack } from "react-icons/io"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { env } from "../../../constants/env";
import axios from "axios";
import { truncateString } from "../../../utilities/functions";

const token = localStorage.getItem("token")

const withDrawalrequest = [
    {
      title: "Request date",
      value: "2024-11-24"
    },
    {
      title: "User",
      value: "Jane Doe"
    },
    {
      title: "Method",
      value: "Crypto (USDT -ERC20)"
    },
    {
      title: "Wallet address",
      value: "0x7Ff5C5eE0C768FE3D..."
    },
    {
      title: "Status",
      value: "Approved"
    },
    {
      title: "Total withdrawal",
      value: "$100.00"
    },
  ]

const users = [
  {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
   {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
  {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
   {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
  {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
   {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
  {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
   {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
  {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  },
   {
    name: "John Doe",
    method: "Crypto (USDT -ERC20)",
    amount: "USD 100.00",
    accountNumber: "1234567890",
    status: "Approved",
    totalWithdrawal: "$100.00"
  }
];

const PastRequests = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showDialog, setShowDialog] = useState();
  const [dialogContent, setDialogContent] = useState(null);
  const [withdrawals, setWithdrawals] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [processType, setProcessType] = useState('');
  const [error, setError] = useState('');
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [withdrawalInfo, setWithdrawalInfo] = useState(null);

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  const columns = [
    { key: "name", label: "Name" },
    { key: "method", label: "Method" },
    { key: "amount", label: "Amount" },
    { key: "accountNumber", label: "Account Number" },
    { key: "status", label: "Status" },
   { key: "totalWithdrawal", label: "Total Withdrawal" }
  ];


  useEffect(() => {
    fetchWithdrawals('manual');
  }, []);

  useEffect(() => {
    if(selectedWithdrawal !== null){
      setWithdrawalInfo(withdrawals[selectedWithdrawal])
    }
 },[selectedWithdrawal])


 const withDrawalrequest = [
  {
    title: "Request date",
    value: withdrawalInfo?.requestDate
  },
  {
    title: "User",
    value: withdrawalInfo?.name
  },
  {
    title: "Method",
    value: withdrawalInfo?.method
  },
  {
    title: "Wallet address",
    value: truncateString(withdrawalInfo?.walletAddress)
  },
  {
    title: "Status",
    value: withdrawalInfo?.status
  },
  {
    title: "Total withdrawal",
    value: withdrawalInfo?.totalWithdrawal
  },
]


  const fetchWithdrawals = async (processType, currentPage = 1) => {
    console.log("FETCHING WITHDRAWALS", processType);
    try {
      const response = await axios.get(`${env.apiUrl}/api/withdraw/withdrawals`, {
        params: { process: processType, status:"resolved", page: currentPage, limit: 10 },
        headers: {
          Authorization: `Bearer ${token}`, // Add token to Authorization header
        },
      });
      setWithdrawals(response.data.withdrawals);
      setTotalPages(response.data.pages);
      setCurrentPage(response.data.page);
      setProcessType(processType);
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Error fetching withdrawals');
    }
  };

  const handlePageChange = (newPage) => {
    fetchWithdrawals(processType, newPage);
  };

  return (
    <div className={classes.wrapper}>
      <div className="mt-3">
        <div className="d-flex align-items-center gap-1" onClick={goBack} role="button">
        <IoIosArrowRoundBack size={30}/><h3>Past requests</h3>
        </div>
      </div>
      <CommonCard className={`${classes.tableCard} mt-4`}>
        <Table
          data={withdrawals}
          dataType={"PastRequests"}
          userInfo={() => {
            setShowDialog(true);
            setDialogContent("info");
          }}
          onClick={(index) => {setSelectedWithdrawal(index); setShowDialog(true)}} 
          columns={columns}
        />

<AlertDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        centerCard={true}
        titleText={dialogContent === "decline" ? "Reason for decline" : "Withdrawal request"}
        showCloseIcon={dialogContent !== "decline"}
        style={{left: `calc(50vw - 225px)`}}
      >
    
            <div className={`row ${classes.contentSection}`}>
            {withDrawalrequest.map((item, i) => (<div className="col-6 mb-3" key={i}>
                <div className={classes.titleText}>{item.title}</div>
                <div className={`${classes.valueText} ${item.value === "Approved" ? classes.successText : item.value === "Declined" && classes.dangerText}`}>{item.value}</div>
              </div>))}
          </div>
          <div className={classes.bottomSection}>
            <div className="d-flex flex-column gap-2">
              <p className={classes.successText}>Payout was done</p>
              <a href="#">Tx hash</a>
              <p className={classes.dateText}> Dec 10, 10:00PM</p>
            </div>
          </div>
          
       
      </AlertDialog>
        <ReactPaginate
          previousLabel={<FaChevronLeft />} // React Icon for left arrow
          nextLabel={<FaChevronRight />} // React Icon for right arrow
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={1}
          onPageChange={handlePageChange}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          previousLinkClassName={`page-link ${
            currentPage === 0 ? "disabled" : ""
          }`}
          nextLinkClassName={`page-link ${
            currentPage === totalPages - 1 ? "disabled" : ""
          }`}
          activeClassName={"active"}
        />
      </CommonCard>
    </div>
  );
};

export default PastRequests;
